import { hot } from 'react-hot-loader'

const Layout = ({ children }) => {
  return children
}

export default hot(module)(Layout)
